export default class DashboardCarouselService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/dashboard_carousels/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/dashboard_carousels', params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/dashboard_carousels', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/dashboard_carousels/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/dashboard_carousels/' + id, params)
	}

	getSettingsData(params){
		return this.apiService.callGet('me/dashboard_carousels/settings_data', params)
	}

	searchShowsByName(params){
		return this.apiService.callGet('me/dashboard_carousels/shows_search', params);
	}

	searchBroadcastsByName(params){
		return this.apiService.callGet('me/dashboard_carousels/broadcasts_search', params);
	}

	getSelectedBroadcastData(params){
		return this.apiService.callGet('dashboard_carousels/selected_broadcast_data', params);
	}
}



// WEBPACK FOOTER //
// ./src/service/DashboardCarouselService.js